import useAppView from "./useAppView";

const AppOnly = ({children}) => {
    const { isAppView } = useAppView();

    if (!isAppView) return null
    return <>
        {children}
    </>
};

export default AppOnly;
